import { createFileRoute, redirect } from "@tanstack/react-router";

// Documentcontrole was /scan-desk until 28-10-2026 (navigatie ronde 2, N17): a bookmark or a link in a
// mail from before still opens it.
export const Route = createFileRoute("/_shell/scan-desk")({
  beforeLoad: () => {
    throw redirect({ to: "/document-check", replace: true });
  },
});
